import {
    toggleValidStep
} from '../../actions';
import {
    CheckOrderData
} from "../CheckOrderData";
import {
    CreditCardNumberField
} from '../fields/creditCardNumber';
import {
    CvvNumberField
} from '../fields/cvvNumber';
import {
    DateField
} from '../fields/dateField';
import {
    TextField
} from '../fields/textField';
import {
    IbanNumberField
} from '../fields/ibanNumber';
import {
    CountrySelectField
} from '../fields/countrySelect';
import {
    PaymentRadioGroupField
} from '../fields/paymentRadioGroupField';
import {
    PAYMENT_TYPE_SEPA,
    PAYMENT_TYPE_CREDIT_CARD,
    EVENT_NAME_STEP_VALIDATE,
    NEW_CUSTOMER,
    EXISTING_CUSTOMER,
    EVENT_NAME_FIELDS_VALIDATE
} from '../../helpers/consts';
import { CheckboxField } from '../fields/checkboxField';
import { CustomerTypeField } from "../fields/customerTypeField";
import { MigrationTypeField } from "../fields/migrationTypeField";

export class PaymentStep {
    /**
     * Component that handles the payment step.
     * @constructor
     * @param {Object} options
     * @param {Store} options.store
     * @param {string} options.id - Step id string
     */
    constructor(options) {
        this.store = options.store;
        this.state = this.store.getState();
        this.translations = options.translations;
        this.isValid = false;
        this.id = options.id;
        this.createStep();
        this.update();
        this.store.subscribe(this.update.bind(this));
    }

    createStep() {
        const $stepContainer = document.createElement('div');
        $stepContainer.classList.add('stepcontainer');
        const $paymentFieldsContainer = document.createElement('div');
        const $migrationFieldsContainer = document.createElement('div');
        const $orderDataContainer = document.createElement('div');
        this.$fieldSetSepa = document.createElement('div');
        this.$fieldSetCreditCard = document.createElement('div');
        this.$fieldSetCheckboxes = document.createElement('div');
        this.$migrationTypeFieldContainer = document.createElement('div');
        const fieldSetSepaHTML = `
<div class="fieldset">
    <div class="row">
        <div class="col-12 field form-group col--field--country"></div>
    </div>
    <div class="row">
        <div class="col-12 field form-group col--field--sepa-name"></div>
    </div>
    <div class="row">
        <div class="col-12 field form-group col--field--sepa-iban-number"></div>
    </div>
</div>
        `;
        const fieldSetCreditCardHTML = `
<div class="fieldset">
    <div class="row">
        <div class="col-12 field form-group col--field--creditcard-name"></div>
    </div>
    <div class="row">
        <div class="col-12 field form-group col--field--credit-card-number"></div>
    </div>
    <div class="row">
        <div class="col-12 col-sm-12 field form-group col--field--expiration-date"></div>
        <div class="col-12 col-sm-12 field form-group col--field--cvv-number"></div>
    </div>
</div>
        `;
        const fieldSetCheckboxesHTML = `
<div class="fieldset">
    <div class="row">
        <div class="col-12 field form-group col--field--monthly-debit"></div>
        <div class="col-12 field form-group col--field--terms-and-conditions"></div>
    </div>
</div>
        `;

        const fieldSetMigrationHTML = `
<div class="fieldset fieldset--migration">
    <h2>${this.translations.migration_title ? this.translations.migration_title : __('Switching arrangement')}</h2>
</div>
        `;

        const fieldSetExistingCustomerHTML = `
<div class="fieldset fieldset--existing-customer">
    <div class="col-12 field form-group col--field--existing-customer"></div>
    <div class="col-12 field form-group col--label--existing-customer">
        ${__('Pay attention! Are you not going to use the switching scheme? Then you continue to pay for your current Exact license. It will NOT end automatically. <a target="_blank" href="https://start.exactonline.nl/docs/BoDocumentViewer.aspx?Document=TransferAgreementCustomer&IsModal=1&BeginModalCallStack=1&_Division_=1">View the conditions here</a>')}
    </div>
</div>
        `;

        $orderDataContainer.classList.add('container--boxed');
        $paymentFieldsContainer.classList.add('container--boxed');
        $migrationFieldsContainer.classList.add('container--boxed');
        this.$fieldSetCreditCard.classList.add('fieldset', 'fieldset--credit-card');
        this.$fieldSetSepa.classList.add('fieldset', 'fieldset--sepa', 'fieldset--active');
        this.$fieldSetCheckboxes.classList.add('fieldset', 'fieldset--checkboxes');
        this.$migrationTypeFieldContainer.classList.add('form-group', 'field-group--existing-customer', 'visually-hidden');

        this.$migrationTypeFieldContainer.innerHTML = fieldSetExistingCustomerHTML;
        this.$fieldSetSepa.innerHTML = fieldSetSepaHTML;
        this.$fieldSetCreditCard.innerHTML = fieldSetCreditCardHTML;
        this.$fieldSetCheckboxes.innerHTML = fieldSetCheckboxesHTML;
        $migrationFieldsContainer.innerHTML = fieldSetMigrationHTML;

        this.$paymentRadioGroup = new PaymentRadioGroupField({
            store: this.store,
            stepId: this.id,
            id: 'paymentType',
            radioButtons: [
                {
                    id: 'sepa',
                    label: __('Direct debit'),
                },
                {
                    id: 'creditcard',
                    label: __('Credit Card'),
                },
            ],
            $context: $stepContainer,
        });

        this.$countrySelectField = new CountrySelectField({
            store: this.store,
            stepId: this.id,
            id: 'country',
            label: __('Bank account location'),
            $context: $stepContainer,
        });

        this.$sepaAccountNameField = new TextField({
            store: this.store,
            stepId: this.id,
            id: 'sepaAccountName',
            label: __('Name on bank account'),
            $context: $stepContainer,
        });

        this.$sepaIbanNumberField = new IbanNumberField({
            store: this.store,
            stepId: this.id,
            id: 'sepaIbanNumber',
            label: __('IBAN bank account'),
            $context: $stepContainer,
        });

        this.$added = [];

        Object.keys(this.translations.added_requirements || {}).forEach(
            (k) => {
                this.$added.push(new CheckboxField({
                    store: this.store,
                    stepId: this.id,
                    id: 'asd',
                    label: this.translations.added_requirements[k].requirements_label,
                    $context: $stepContainer,
                    info: this.translations.added_requirements[k].requirements_info
                }))
            }
        );

        this.$authorizeMonthlyDebitField = new CheckboxField({
            store: this.store,
            stepId: this.id,
            id: 'authorizeMonthlyDebit',
            label: this.translations.optin_incasso ? this.translations.optin_incasso : __('Yes, I give permission to Exact Netherlands B.V. to send ongoing collection instructions to my bank to debit amounts from my account in relation to the Exact Online agreement.'),
            $context: $stepContainer,
        });

        this.$termsAndConditionsField = new CheckboxField({
            store: this.store,
            stepId: this.id,
            id: 'termsAndConditions',
            label: this.translations.optin_general_terms ? this.translations.optin_general_terms : (__('I agree to the %s of Exact').replace(/%s/g, ('<a href="https://start.exactonline.nl/docs/BoDocumentViewer.aspx?Document=LicenseAgreement&IsModal=1&BeginModalCallStack=1&_Division_=1" target="_blank" rel="noopener noreferrer">%s</a>').replace(/%s/g, __('terms and conditions') ))),
            $context: $stepContainer,
        });


        this.$customerTypeField = new CustomerTypeField({
            store: this.store,
            id: 'customerType',
            stepId: this.id,
            label: __('Customer type'),
            radioButtons: [
                {
                    id: NEW_CUSTOMER,
                    label: this.translations.migration_new ? this.translations.migration_new : __('I am a new customer of Exact'),
                },
                {
                    id: EXISTING_CUSTOMER,
                    label: this.translations.migration_existing ? this.translations.migration_existing : __('I am an existing customer of Exact'),
                },
            ],
            $context: $stepContainer,
        });

        this.$migrationTypeField = new MigrationTypeField({
            store: this.store,
            stepId: this.id,
            id: 'migrationType',
            label: __('Migration type'),
            $context: $stepContainer,
        });


        this.$fieldSetSepa.querySelector('.col--field--country').appendChild(this.$countrySelectField.render());
        this.$fieldSetSepa.querySelector('.col--field--sepa-name').appendChild(this.$sepaAccountNameField.render());
        this.$fieldSetSepa.querySelector('.col--field--sepa-iban-number').appendChild(this.$sepaIbanNumberField.render());

        this.$creditCardAccountNameField = new TextField({
            store: this.store,
            stepId: this.id,
            id: 'ccAccountName',
            label: __('Name of the cardholder'),
            $context: $stepContainer,
        });

        this.$creditCardNumberField = new CreditCardNumberField({
            store: this.store,
            stepId: this.id,
            id: 'ccnumber',
            label: __('Credit card number'),
            $context: $stepContainer,
        });

        this.$cvvNumberField = new CvvNumberField({
            store: this.store,
            stepId: this.id,
            id: 'cvvnumber',
            label: __('Security code'),
            $context: $stepContainer,
        });

        this.$expirationDateField = new DateField({
            store: this.store,
            stepId: this.id,
            id: 'expirationDate',
            label: __('Expiration date'),
            $context: $stepContainer,
        });

        this.$fieldSetCreditCard.querySelector('.col--field--creditcard-name').appendChild(this.$creditCardAccountNameField.render());
        this.$fieldSetCreditCard.querySelector('.col--field--credit-card-number').appendChild(this.$creditCardNumberField.render());
        this.$fieldSetCreditCard.querySelector('.col--field--expiration-date').appendChild(this.$expirationDateField.render());
        this.$fieldSetCreditCard.querySelector('.col--field--cvv-number').appendChild(this.$cvvNumberField.render());
        this.$checkOrderData = new CheckOrderData({
            store: this.store,
        });

        this.$added.forEach((e) => this.$fieldSetCheckboxes.querySelector('.col--field--monthly-debit').appendChild(e.render()));
        this.$fieldSetCheckboxes.querySelector('.col--field--monthly-debit').appendChild(this.$authorizeMonthlyDebitField.render());
        this.$fieldSetCheckboxes.querySelector('.col--field--terms-and-conditions').appendChild(this.$termsAndConditionsField.render());

        $paymentFieldsContainer.appendChild(this.$paymentRadioGroup.render());
        $paymentFieldsContainer.appendChild(this.$fieldSetSepa);
        $paymentFieldsContainer.appendChild(this.$fieldSetCreditCard);
        $paymentFieldsContainer.appendChild(this.$fieldSetCheckboxes);
        $orderDataContainer.appendChild(this.$checkOrderData.render());
        $stepContainer.appendChild($paymentFieldsContainer);

        $migrationFieldsContainer.appendChild(this.$customerTypeField.render());
        this.$migrationTypeFieldContainer.querySelector('.col--field--existing-customer').appendChild(this.$migrationTypeField.render());

        $migrationFieldsContainer.appendChild( this.$migrationTypeFieldContainer);

        if (this.state.settings.has_migration_arrangement) {
            $stepContainer.appendChild($migrationFieldsContainer);
        }

        $stepContainer.appendChild($orderDataContainer);
        $stepContainer.addEventListener(EVENT_NAME_STEP_VALIDATE, this.validateStep.bind(this));
        $stepContainer.addEventListener(EVENT_NAME_FIELDS_VALIDATE, () => {
            this.$sepaAccountNameField.validate();
            this.$sepaIbanNumberField.validate();
            this.$authorizeMonthlyDebitField.validate();
            this.$termsAndConditionsField.validate();
        });

        this.$el = $stepContainer;
    }

    validateStep() {
        const validateMigrationTypeField = this.$customerTypeField.value === `radio-${EXISTING_CUSTOMER}`;
        const migrationTypeFieldIsValid = validateMigrationTypeField ? this.$migrationTypeField.valid() : this.$customerTypeField.valid();

        if (this.$paymentRadioGroup.value === `radio-${PAYMENT_TYPE_SEPA}`) {
            this.isValid = this.$sepaAccountNameField.valid() && this.$sepaIbanNumberField.valid()  && this.$countrySelectField.valid() &&this.$authorizeMonthlyDebitField.valid() && this.$termsAndConditionsField.valid() && (migrationTypeFieldIsValid || !this.state.settings.has_migration_arrangement);
        } else if (this.$paymentRadioGroup.value === `radio-${PAYMENT_TYPE_CREDIT_CARD}`) {
            this.isValid = this.$creditCardAccountNameField.valid() && this.$creditCardNumberField.valid() && this.$cvvNumberField.valid() && this.$expirationDateField.valid() &&this.$authorizeMonthlyDebitField.valid() && this.$termsAndConditionsField.valid() && (migrationTypeFieldIsValid || !this.state.settings.has_migration_arrangement);
        }

        if (this.isValid && this.$added.length) {
            let i = 0;
            for (; i < this.$added.length; i += 1) {
                if (!this.$added[i].valid()) {
                    this.isValid = false;
                    break;
                }
            }
        }

        this.store.dispatch(toggleValidStep(this.id, this.isValid));
    }

    render() {
        return this.$el;
    }

    update() {
        this.state = this.store.getState();

        const paymentTypeField = this.state.formFields.find(field => field.id === 'paymentType');

        this.$fieldSetCreditCard.classList.toggle('fieldset--active', paymentTypeField.value === 'radio-creditcard');
        this.$fieldSetSepa.classList.toggle('fieldset--active', paymentTypeField.value !== 'radio-creditcard');

        if (this.$customerTypeField.value === `radio-${NEW_CUSTOMER}`) {
            this.$migrationTypeFieldContainer.classList.add('visually-hidden');
        }

        if (this.$customerTypeField.value === `radio-${EXISTING_CUSTOMER}`) {
            this.$migrationTypeFieldContainer.classList.remove('visually-hidden');
        }
    }
}

export default PaymentStep;
